export const DOCUMENT_TYPE_CONFIG = "v1/document-types";
export const DOCUMENT_TYPE_CONFIG_BY_COMMUNITY = (communityId: string) =>
  `${DOCUMENT_TYPE_CONFIG}/community/${communityId}`;